<template lang="pug">
v-container.View.View--ResetPassword
  v-card
    v-card-text.py-6
      .title.mb-2 Reset della password
      ValidationObserver(v-slot="{ invalid, validated, passes }")
        v-form
          v-layout(wrap)
            v-flex(xs12)
              ValidationProvider(name="Password" rules="required|min:6" v-slot="{ errors }" vid="password")
                v-text-field(
                  v-model="form.newPassword" required
                  name="nuova password" type="password"
                  :error-messages="errors"
                  label="Nuova Password" prepend-inner-icon="mdi-asterisk"
                )
          v-layout(wrap)
            v-flex(xs12)
              v-btn.primary(
                @click="passes(resetPassword)" :disabled="invalid || !validated"
                :loading="loading" block
              ) Imposta nuova password
</template>

<script>
import Merchant from "@/api/Merchant";

export default {
  data: () => ({
    form: {
      newPassword: null,
      token: null
    },

    loading: false
  }),

  mounted() {
    this.$emit("update:title", "Reset Password");

    const token = this.$route.query.token;
    if (!token) {
      this.$router.replace({ name: "auth.login" });
      return;
    }
    this.form.token = token;
  },

  methods: {
    goBack() {
      window.history.length > 0
        ? this.$router.go(-1)
        : this.$router.push({ name: "home" });
    },

    async resetPassword() {
      this.loading = true;
      await Merchant.resetPassword(this.form);
      this.loading = false;

      this.$router.replace({
        name: "auth.login",
        params: { passwordReset: true }
      });
    }
  }
};
</script>
